import { notifyError } from "../Components/notify/notify-component";
import globals from "../Globals.json";
import api from "./api";

export const createMovementType = async (objMovementType: any) => {
  if (objMovementType.uuid) {
    return api
      .put(
        `${globals.api.movementsTypes}/${objMovementType.uuid}`,
        objMovementType,
      )
      .then((res: any) => {
        if (res.status === 201 || res.status === 200) {
          const objCallback = {
            data: res.data.data,
            status: true,
          };
          return objCallback;
        }
      })
      .catch((error: any) => {
        notifyError(error);
      });
  } else {
    return api
      .post(`${globals.api.movementsTypes}`, objMovementType)
      .then((res: any) => {
        if (res.status === 201 || res.status === 200) {
          const objCallback = {
            data: res.data.data,
            status: true,
          };
          return objCallback;
        }
      })
      .catch((error: any) => {
        notifyError(error);
      });
  }
};

export const getMovementTypes = () => {
  return api.get(`${globals.api.movementsTypes}`);
};
